/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Edit_DescriptionInputs */

const en_admin_payments_edit_description = /** @type {(inputs: Admin_Payments_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update order status and product information`)
};

const zh_admin_payments_edit_description = /** @type {(inputs: Admin_Payments_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修改订单状态和产品信息`)
};

/**
* | output |
* | --- |
* | "Update order status and product information" |
*
* @param {Admin_Payments_Edit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_edit_description = /** @type {((inputs?: Admin_Payments_Edit_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Edit_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_edit_description(inputs)
	return zh_admin_payments_edit_description(inputs)
});
export { admin_payments_edit_description as "admin.payments.edit_description" }